export const SAVE_ALL_READJUSTMENT_INDICES = 'SAVE_ALL_READJUSTMENT_INDICES'
export const SAVE_READJUSTMENT_INDICE = 'SAVE_READJUSTMENT_INDICE'
